module.exports = __webpack_public_path__ + "img/plants-7933494_1280_thumb.1b60e01c.jpg";